import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import logo from "@/assets/falkors-walls-logo.png";

interface NavigationProps {
  onContactClick?: () => void;
}

const Navigation = ({ onContactClick }: NavigationProps) => {
  return (
    <nav className="fixed top-0 w-full z-50 bg-background/95 backdrop-blur-lg border-b-2 border-border shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center hover:opacity-80 transition-opacity">
            <img src={logo} alt="Falkors Walls - Professional Climbing Gym Construction and Bouldering Gym Builder Logo" className="h-12 w-auto" />
          </Link>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <a href="#services" className="text-foreground hover:text-primary transition-colors font-medium relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-primary after:transition-all">
              Services
            </a>
            <a href="#projects" className="text-foreground hover:text-primary transition-colors font-medium relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-primary after:transition-all">
              Projects
            </a>
            <a href="#process" className="text-foreground hover:text-primary transition-colors font-medium relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-primary after:transition-all">
              Process
            </a>
            <a href="#why" className="text-foreground hover:text-primary transition-colors font-medium relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:bg-primary after:transition-all">
              Why Us
            </a>
            <Button onClick={onContactClick || (() => {})} size="lg" className="bg-gradient-primary text-primary-foreground shadow-lg hover:shadow-xl hover:scale-105 transition-all">
              Contact
            </Button>
          </div>
          
          {/* Mobile Menu Button */}
          <button className="md:hidden text-foreground" aria-label="Open navigation menu">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;